import React from "react";
import { motion } from "framer-motion";

import Lottie from "lottie-react";
import logisticsAnimation from "../../animations/logistics.json"; // Replace with your Lottie JSON animation file
import hrmAnimation from '../../animations/hrm.json'
import crmAnimation from '../../animations/crm.json'
import analyticsAnimation from '../../animations/analytics.json'

function HeroSection() {
  return (
    <section className="relative bg-[#0A0F1F] text-white py-4 mt-28 overflow-hidden">

      {/* Main Content */}
      <div className="container mx-auto px-6 lg:flex lg:items-center lg:justify-between">
        {/* Left Section */}
        <div className="lg:w-1/2 text-center lg:text-left">
          <h1 className="text-l leading-tight mb-10">
            <span className="bg-clip-text bg-gradient-to-r from-yellow-400 to-cyan-400">
              ENTERPRISE RESOURCE PLANNING SOFWTARE
            </span>
          </h1>
          <h2 className="text-3xl font-medium mt-2">
            Smart, Efficient, <span className="text-yellow-400">Seamless</span>
          </h2>
          <p className="mt-6 text-gray-300 max-w-md">
            Revolutionize your business operations with our powerful AI-driven ERP system designed for speed, intelligence, and simplicity.
          </p>
          <div className="mt-8 flex justify-center lg:justify-start gap-4">
            <button className="px-8 py-3 bg-yellow-400 text-gray-900 font-semibold rounded-md shadow-md hover:bg-yellow-300 transition">
              Get Started
            </button>
            <button className="px-8 py-3 border border-gray-700 text-gray-300 font-semibold rounded-md hover:border-yellow-400 hover:text-yellow-400 transition">
              Learn More
            </button>
          </div>
        </div>

        {/* Right Section */}
        <div className="lg:w-2/3 mt-12 lg:mt-0 relative">

          {/* Panels */}
          <div className="grid grid-cols-2 gap-2">
            
            {/* Panel 1: Supply Chain */}
            <div className="w-50 h-50  rounded-lg p-1 shadow-lg">
              <Lottie animationData={logisticsAnimation} loop={true} />
            </div>

            {/* Panel 2: Revenue & CRM */}
            <div className="w-50 h-50 rounded-lg p-1 shadow-lg">
              <Lottie animationData={crmAnimation} loop={true} />
            </div>

             {/* Panel 3: KPIs & Analytics */}
             <div className="w-50 h-50 rounded-lg p-1 shadow-lg">
              
              <Lottie animationData={analyticsAnimation} loop={true} />
            </div>

            {/* Panel 4: HRM */}
            <div className="w-50 h-50  rounded-lg p-1 shadow-lg">
              <Lottie animationData={hrmAnimation} loop={true} />
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;